import FeaturedListingType from '@domain-group/fe-allhomes-library/lib/enums/featured-listing-type';
import { lookupFeaturedProperty } from '../utils';
var updateFeaturedProperty = (query, props, state) => lookupFeaturedProperty(query, props, state, FeaturedListingType.FEATURED_PROPERTY);
export default {
  extraTasks: [updateFeaturedProperty]
};